
<v-tooltip class="help-tooltip" top>
  <template v-slot:activator="{ on }">
    <v-icon :class="{'tooltip-icon-inline': inline}" class="helpIcon" v-on="on">
      help_outline
    </v-icon>
  </template>
  <span><slot/></span>
</v-tooltip>
